import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCodeTree: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"code-tree, file-tree"} maskId="square-outlined-radius-0-stroke-1-IconCodeTree"><path d="M4.5 3V17.5H14.5" stroke="currentColor"/><path d="M4.5 9.5H14.5" stroke="currentColor"/><circle cx="17" cy="17.5" r="2.5" stroke="currentColor"/><circle cx="17" cy="9.5" r="2.5" stroke="currentColor"/></CentralIconBase>;
}));

export default IconCodeTree;
